import {ref, computed, unref, watchEffect, onBeforeUnmount} from "vue";
import {audioEnabled} from "@/audio";
const alertSound = new Audio(require('assets/sounds/glockenspiel.mp3'))


let nextComponentId = 0;
let blinkingComponents = new Set();

const isBlinkActive = ref(false);
let hadAudioNotAllowedError = false;

setInterval(() => {
    isBlinkActive.value = !isBlinkActive.value;
    if (blinkingComponents.size > 0 && isBlinkActive.value === true) {
        if (!audioEnabled.value) {
            return;
        }

        alertSound.play().catch((error) => {
            if (error instanceof DOMException && error.name === 'NotAllowedError') {
                if (hadAudioNotAllowedError) {
                    return;
                }
                console.warn(error);
                hadAudioNotAllowedError = true;
                return;
            }
            console.error(error);
        });
    }
}, 1000);

export function useBlinking(doAlert) {
    const componentId = ++nextComponentId;
    const isAlertActive = ref(false);

    // Side effects live here — NOT in the computed getter.
    // watchEffect re-runs whenever doAlert()'s reactive dependencies change.
    watchEffect(() => {
        const alertEnabled = unref(doAlert());
        if (alertEnabled) {
            blinkingComponents.add(componentId);
        } else {
            blinkingComponents.delete(componentId);
        }
        isAlertActive.value = alertEnabled;
    });

    onBeforeUnmount(() => {
        blinkingComponents.delete(componentId);
    });

    // Pure computed. isAlertActive is checked first so non-alerted components
    // never read isBlinkActive and are not subscribed to 1s blink ticks.
    return computed(() => isAlertActive.value && isBlinkActive.value);
}
